<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
    <div class="bg-white bg-opacity-10 backdrop-blur-xl p-8 rounded-2xl w-full max-w-md border border-white border-opacity-20 shadow-2xl transform transition-all duration-300">
      <!-- Logo Header -->
      <div class="mb-6 text-center">
        <div class="flex items-center justify-center">
          <span class="text-white text-3xl font-bold">inter<span class="text-yellow-300">bot</span></span>
          <div class="ml-2 bg-yellow-300 p-1 rounded-md">
            <span class="text-xs font-bold text-blue-700">IA</span>
          </div>
        </div>
      </div>
      
      <!-- Description -->
      <p class="text-white text-opacity-90 text-center mb-6">
        Copia el código o la liga de entrevista para que puedas regresar a esta sesión en cualquier momento.
      </p>
      
      <!-- Code Input -->
      <div class="mb-6">
        <label class="block text-white font-bold mb-2">Código único de entrevista:</label>
        <div class="flex flex-col sm:flex-row gap-2">
          <input type="text" :value="intCode" ref="codeInput" readonly
            class="flex-1 bg-white bg-opacity-20 border border-white border-opacity-20 rounded-lg py-3 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-300 shadow-inner" />
          <button @click="copyCode"
            class="bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium py-3 px-4 rounded-lg transition-all duration-300 hover:shadow-lg transform hover:scale-105 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
            </svg>
            Copiar
          </button>
        </div>
      </div>
      
      <!-- Link Input -->
      <div class="mb-6">
        <label class="block text-white font-bold mb-2">Liga a la entrevista:</label>
        <div class="flex flex-col sm:flex-row gap-2">
          <input type="text" :value="interviewLink" ref="linkInput" readonly
            class="flex-1 bg-white bg-opacity-20 border border-white border-opacity-20 rounded-lg py-3 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-300 shadow-inner" />
          <button @click="copyLink"
            class="bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium py-3 px-4 rounded-lg transition-all duration-300 hover:shadow-lg transform hover:scale-105 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
            </svg>
            Copiar
          </button>
        </div>
      </div>
      
      <!-- Close Button -->
      <div class="flex justify-center">
        <button @click="$emit('close')"
          class="bg-white bg-opacity-20 backdrop-blur-sm hover:bg-opacity-30 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 hover:shadow-lg transform hover:scale-105 shadow-md border border-white border-opacity-20">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
props: {
  interviewLink: { type: String, required: true },
  intCode: { type: String, required: true }
},
methods: {
  copyCode() {
    const input = this.$refs.codeInput;
    input.select();
    document.execCommand('copy');
  },
  copyLink() {
    const input = this.$refs.linkInput;
    input.select();
    document.execCommand('copy');
  }
}
}
</script>

<style scoped>
.backdrop-blur-sm {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.backdrop-blur-xl {
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.hover\:scale-105:hover {
  transform: scale(1.05);
}

/* Focus styles for inputs */
input:focus {
  border-color: rgba(250, 204, 21, 0.5);
}

input::selection {
  background-color: rgba(250, 204, 21, 0.3);
  color: white;
}
</style>